export default __webpack_public_path__ + "static/media/map.d1fdeab2.jpg";